var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { SnackbarProvider } from 'notistack';
import { spacingToRem } from '../../utils/units';
import { USED_SPACING } from './NotificationsProvider';
var NotificationsProvider = styled(SnackbarProvider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 ", " !important;\n"], ["\n  padding: 0 ", " !important;\n"])), function (props) { return spacingToRem(USED_SPACING, props.theme.spacing, true); });
export { NotificationsProvider };
var templateObject_1;
//# sourceMappingURL=styles.js.map